import React, { Component } from 'react'
import PopoverFit from 'components/Popover/PopoverFit'
import { uniqueId } from 'lodash'

import IconChevronDown from 'components/Icons/ChevronDown'
import InputMessage from '../InputMessage'
import AutosizeInput from 'react-input-autosize'
import { Checkbox } from 'components/Input/Checkbox'
import cn from 'classnames'
import s from './SelectPretty.scss'
import sInput from '../Input/Input.scss'
import sLay from 'styles/modules/layout.scss'

export default class SelectPretty extends Component {
  constructor(props) {
    super(props)
    this.state = {
      inputId: uniqueId('input'),
    }
  }
  onSelectFromDropdown = value => {
    const { input, onChangeAlt, multiselect } = this.props
    const currentValue = input.value
    const newValue = multiselect ? this.getNewValueMutliselect(currentValue, value) : value
    input.onChange(newValue)
    if (onChangeAlt) onChangeAlt(newValue)
    this.setState({ selectItem: '' })
  }
  getNewValueMutliselect = (currentValue, value) => {
    if (currentValue.includes(value)) {
      return currentValue.filter(item => item !== value)
    }
    return [...currentValue, value]
  }
  onBlurTimeout = undefined
  onBlur = () => {
    const { input } = this.props
    clearTimeout(this.onBlurTimeout)
    this.onBlurTimeout = setTimeout(input.onBlur, 100)
  }
  onFocus = () => {
    const { input } = this.props
    clearTimeout(this.onBlurTimeout)
    input.onFocus()
  }
  render() {
    const {
      input,
      options,
      className,
      multiselect,
      placeholder,
      manualInputPlaceholder,
      label,
      display,
      color,
      manualInput,
      valueTransform,
      info,
      meta: { touched, error, warning, active },
    } = this.props
    const { inputId } = this.state
    const selectedNames = options
      .filter(option =>
        multiselect ? input.value.includes(option.value) : option.value === input.value
      )
      .map(item => item.name)

    const valueJoined = selectedNames.join(', ')
    const valueDisplay = valueTransform ? valueTransform(valueJoined) : valueJoined

    const outerClasses = cn(
      { [sInput.outerBoxed]: display === 'box' },
      { [sInput.outer]: !display },
      { [sInput.outerInline]: display === 'inline' },
      { [sInput.invalid]: touched && error },
      { [sInput.white]: color === 'white' },
      {
        [sInput.inactive]: (input.value === undefined || input.value.length === 0) && !valueDisplay,
      },
      className
    )

    const inputProps = {
      autoComplete: 'off',
      className: display === 'inline' ? '' : sInput.standard,
      onChange: () => {},
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      value: valueDisplay || input.value || '',
      placeholder,
    }

    return (
      <PopoverFit open={active} trigger="none" preferPlace="below">
        <div className={outerClasses}>
          <label htmlFor={inputId}>{label}</label>
          <a className={sInput.arrow} onClick={this.onFocus} onBlur={this.onBlur}>
            <IconChevronDown />
          </a>
          {display === 'inline' ? (
            <AutosizeInput {...inputProps} readOnly="readonly" />
          ) : (
            <input {...inputProps} readOnly="readonly" />
          )}
          {display !== 'box' && display !== 'inline' && (
            <InputMessage error={error} warning={warning || info} touched={touched} />
          )}
        </div>
        <div className={s.popup}>
          {options.map((item, idx) => (
            <a
              key={idx}
              onClick={() =>
                item.onClick ? item.onClick() : this.onSelectFromDropdown(item.value)
              }
              className={cn(
                { [s.active]: !multiselect && input.value === item.value },
                sLay['layout-row'],
                sLay['layout-align-start-center']
              )}
            >
              {multiselect && (
                <Checkbox
                  input={{
                    value: input.value.includes(item.value),
                    onChange: () => this.onSelectFromDropdown(item.value),
                  }}
                  meta={{}}
                  style={{ marginRight: '10px' }}
                />
              )}
              {valueTransform ? valueTransform(item.name) : item.name}
            </a>
          ))}
          {options && options.length === 0 && <a className={sLay['layout-row']}>No options</a>}
          {manualInput && (
            <div className={s.inputRow}>
              <input
                autoComplete="off"
                onChange={this.onSelectFromDropdown}
                onFocus={this.onFocus}
                onBlur={this.onBlur}
                placeholder={manualInputPlaceholder}
              />
            </div>
          )}
        </div>
      </PopoverFit>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Input/SelectPretty/SelectPretty.jsx